import SectionHeading from '@common/SectionHeading';
import React from 'react';

export interface HeadingProps {
  text?: string;
  className?: string;
  as?: React.ElementType;
  children?: React.ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ className, ...props }) => {
  return (
    <div className={`block ${className}`}>
      <div className={`w-fit inline-block`}>
        <div className="flex justify-between items-center">
          <div className="w-54 bg-decBg h-2 hidden md:block mr-8"></div>
          <SectionHeading className={'text-center'} {...props} />
          <div className="w-54 bg-decBg h-2 hidden md:block ml-8"></div>
        </div>
      </div>
    </div>
  );
};

export default Heading;
